const defaultState = {
  showing_message_box: false,
  contact_details: null, // null initially, hide the MessageBox until it has a value (even when never used, set to an empty object)
  message_history: {}, // history of all messages sent to vendors from this device
  is_sending: false, // Used to show loading/sending UI
};

export default function contactReducer(state = defaultState, action) {
  switch (action.type) {
    case 'GET_FORM_CONTACT_DETAILS': {
      return {
        ...state,
        contact_details: action.payload,
      };
    }
    case 'SEND_ENQUIRY_STARTED': {
      return {
        ...state,
        is_sending: true,
      };
    }
    case 'SEND_ENQUIRY_COMPLETE':
    case 'GET_MESSAGE_HISTORY': {
      return {
        ...state,
        message_history: action.messageHistory,
        is_sending: false,
      };
    }
    case 'SEND_ENQUIRY_FAILED': {
      return {
        ...state,
        is_sending: false,
      };
    }
    case 'SHOW_MESSAGE_BOX': {
      return {
        ...state,
        showing_message_box: true,
      };
    }
    case 'HIDE_MESSAGE_BOX': {
      return {
        ...state,
        showing_message_box: false,
      };
    }
    case 'SET_MESSAGE_BOX': {
      return {
        ...state,
        showing_message_box: action.to,
      };
    }
    default:
      return state;
  }
}
